import { findReferenceBasketVersions as findMaxPriceReferenceBasketVersions } from '~/Api/CzPriceReferencing/MaxPrice';
import { findReferenceBasketVersions as findReimbursementReferenceBasketVersions } from '~/Api/CzPriceReferencing/Reimbursement';
import { findReferenceBasketVersions as findRoMaxPriceReferenceBasketVersions } from '~/Api/RoPriceReferencing/MaxPrice';
import { findReferenceBasketVersions as findSkMaxPriceReferenceBasketVersions } from '~/Api/SkPriceReferencing/MaxPrice';
import { invokeApi } from '~/ApiClient';
import { handleError } from '~/ErrorHandler';
import { ThunkAction } from '~/Store';

import { Action, ActionType } from './Action';
import { Module } from './Module';

export function fetchReferenceBasketVersionsIfNeeded(module: Module): ThunkAction<Promise<void>, Action> {
	return async (dispatch, getState) => {
		const { priceReferencing } = getState();
		const request =
			priceReferencing.module === module && priceReferencing.request !== null
				? priceReferencing.request
				: dispatch(fetchReferenceBasketVersions(module));
		await request;
	};
}

export function fetchReferenceBasketVersions(module: Module): ThunkAction<Promise<void>, Action> {
	return async (dispatch) => {
		const request = dispatch(createReferenceBasketVersionsRequest(module));
		dispatch({ type: ActionType.request, request, module });

		try {
			const response = await request;
			dispatch({ type: ActionType.receive, request, versions: response.items });
		} catch (error) {
			dispatch({ type: ActionType.receive, request, versions: null });
			dispatch(handleError(error));
		}
	};
}

function createReferenceBasketVersionsRequest(
	module: Module
): ThunkAction<Promise<{ items: Array<{ id: string }> }>, Action> {
	return (dispatch) => {
		switch (module) {
			case Module.czMaxPrice:
				return dispatch(invokeApi(findMaxPriceReferenceBasketVersions));
			case Module.czReimbursement:
				return dispatch(invokeApi(findReimbursementReferenceBasketVersions));
			case Module.skMaxPrice:
				return dispatch(invokeApi(findSkMaxPriceReferenceBasketVersions));
			case Module.roMaxPrice:
				return dispatch(invokeApi(findRoMaxPriceReferenceBasketVersions));
			default:
				throw new Error();
		}
	};
}

export function pruneReferenceBasketVersions(): Action {
	return { type: ActionType.prune };
}
